import React from 'react';
import type { NodeAuthority } from '@/data/kavrisData';

interface AuthorityBadgeProps {
  authority: NodeAuthority;
  size?: 'xs' | 'sm' | 'md';
}

const authorityConfig: Record<NodeAuthority, { label: string; class: string }> = {
  Codex: { label: 'Codex', class: 'text-primary border-primary/20 bg-primary/5' },
  Atlas: { label: 'Atlas', class: 'text-accent-foreground border-accent/20 bg-accent/5' },
  Foundation: { label: 'Foundation', class: 'text-[#22c55e] border-[#22c55e]/20 bg-[#22c55e]/5' },
  'Product Framework': { label: 'Product Framework', class: 'text-[#f59e0b] border-[#f59e0b]/20 bg-[#f59e0b]/5' },
  Prototype: { label: 'Prototype', class: 'text-muted-foreground border-border bg-muted/30' },
};

export default function AuthorityBadge({ authority, size = 'sm' }: AuthorityBadgeProps) {
  const config = authorityConfig[authority];
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-[11px]',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span
      className={`inline-flex items-center rounded border font-mono-data font-medium tracking-wide ${sizeClasses[size]} ${config.class}`}
    >
      {config.label}
    </span>
  );
}